export const HOME_ROUTE = '/'
export const ABOUT_ROUTE = '/about'
export const BLOGS_ROUTE = '/blogs'
export const CONTACT_ROUTE = '/contact'
export const SERVICES_ROUTE = '/services'
export const BUILDING_SUCCESSFUL_WEBSITES_ROUTE = '/building-successful-websites'
export const DIGITAL_ROADMAPS_FOR_SMES_ROUTE = '/digital-roadmap-for-smes'
export const LANDING_PAGES_FOR_LEADS_ROUTE = '/landing-pages-for-leads'
export const PAYMENTS_DIGITAL_TRANSFORMATION_ROUTE = '/payments-digital-transformation'
export const NONPROFIT_WEBSITE_BENEFITS_ROUTE = '/nonprofit-website-benefits'
export const NOT_FOUND = '/404'

export const LINKEDIN_ROUTE = 'https://www.linkedin.com/in/abdielalvarezrojas/'
export const GITHUB_ROUTE = 'https://github.com/abdielalvarez'
export const MEDIUM_ROUTE = 'https://medium.com/@abdy4lvarez'

export const COMPANY_1 = 'https://contactaabogado.com/'
export const COMPANY_2 = 'https://inventialab.com/'
export const COMPANY_3 = 'https://www.ion.com.mx/'

export const WHATSAPP_ROUTE = 'https://wa.me/529221745112'
export const EMAIL_ROUTE = 'mailto:abdielalvarez@icloud.com'